import { Icon, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';

import * as S from './style';

export function StepIndex({ stepIndex = 1, isCompleted = false, hasWarning = false }) {
  return (
    <S.StepIndex isCompleted={isCompleted} hasWarning={hasWarning}>
      {hasWarning ? (
        <Icon name="f-warning" size="lg" />
      ) : isCompleted ? (
        <Icon name="success" size="lg" />
      ) : (
        <Typography variant="subtitle2Bold" color="fg" emphasis="weakest2">
          {stepIndex}
        </Typography>
      )}
    </S.StepIndex>
  );
}

StepIndex.propTypes = {
  stepIndex: PropTypes.number,
  isCompleted: PropTypes.bool
};
